import { render, staticRenderFns } from "./financeiro-pontuacao-profissional.vue?vue&type=template&id=05529854&scoped=true"
import script from "./financeiro-pontuacao-profissional.vue?vue&type=script&lang=ts"
export * from "./financeiro-pontuacao-profissional.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-pontuacao-profissional.vue?vue&type=style&index=0&id=05529854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05529854",
  null
  
)

export default component.exports